import { useState, useEffect } from 'react';

const NARROW_BREAKPOINT = 480;

export const useNarrowMobile = () => {
  const [isNarrow, setIsNarrow] = useState(
    () => window.innerWidth <= NARROW_BREAKPOINT
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${NARROW_BREAKPOINT}px)`);
    setIsNarrow(mq.matches);
    const handler = (e: MediaQueryListEvent) => setIsNarrow(e.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, []);

  return isNarrow;
};
